export default "<div [id]=\"viewerId\" class=\"reportContainer\"></div>\r\n<p *ngIf=\"error\">No se han podido cargar los datos</p>"